import { IGetAllItensChecklistUseCase } from "../../../presentation/useCases/read/get_all_itens_checklist_use_case";
import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { IProjetosRepository } from "../../repositories/projetos_repository";
import { ItemChecklistLista } from "../../models/ItemChecklistLista";

export class GetAllItensChecklistUseCase
  extends BasePaginatedUseCase<ItemChecklistLista>
  implements IGetAllItensChecklistUseCase
{
  constructor(private readonly repository: IProjetosRepository) {
    super();
  }

  async getAllItensChecklist(page: number, rowsPerPage: number, idChecklist: number): Promise<void> {
    const response = await this.repository.getAllItensChecklist(page, rowsPerPage, idChecklist);

    this._items = response.items;
    this._totalPages = response.totalPages;
    this._totalItems = response.totalItems;
    this._currentPage = response.currentPage;
    this._pageSize = response.pageSize;
  }
}
